import { extractUserFromAuthResponse, setAuthUserInStorage } from '@/utils/auth/common/auth-storage';

/**
 * Shared post-login side effect for all auth flows (local, SSO, SAML): normalize the
 * response into a user object and persist it (fires `userDataUpdated`). Returns null only
 * when no user was recognizable — callers treat that as "show an error, don't redirect".
 */
export function finalizeClientLogin(responseBody: unknown): Record<string, unknown> | null {
  const userData = extractUserFromAuthResponse(responseBody);
  if (!userData) return null;

  // Storage failure isn't a failed login — the session cookie is already set server-side;
  // useAuthUser() will recover the profile from /api/auth/session on next read.
  if (!setAuthUserInStorage(userData)) {
    console.warn('[auth] could not persist user to localStorage; session is still active');
  }

  return userData;
}
